export const usernameRules = {
  required: "メールアドレスは必須です",
  pattern: {
    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    message: "メールアドレスの形式が正しくありません",
  },
};

export const passwordRules = {
  required: "パスワードは必須です",
  minLength: {
    value: 8,
    message: "パスワードは8文字以上でなければなりません",
  },
  validate: (value: string) => {
    if (!/[A-Z]/.test(value)) return "英大文字を含めてください";
    if (!/[a-z]/.test(value)) return "英小文字を含めてください";
    if (!/\d/.test(value)) return "数字を含めてください";
    if (!/[!@#$%^&*()\[\]\\,.?":{}|<>%_\/\-=+`~';]/.test(value))
      return "記号(!@#$%など)を含めてください";
    return true;
  },
};

export const otpRules = {
  required: "OTPは必須です",
  pattern: {
    value: /^\d{6}$/,
    message: "OTPは6桁の数字である必要があります",
  },
};

export const confirmPasswordRules = (password: string) => ({
  required: "確認用パスワードは必須です",
  validate: (value: string) => value === password || "パスワードが一致しません",
});
